<template>
  <div
    :class="_.waterfall"
    :style="{
      '--category-color': theme.classifyFontColor,
      '--category-color-active': theme.classifyFocusColor,
      '--category-bgcolor': theme.unCheckedBackgroundColor,
      '--category-bgcolor-active': theme.classifyFocusIconColor,
    }"
  >
    <div :class="_.bd">
      <DmbcBaseTabs
        v-if="data.length > 1"
        v-model="categoryIndex"
        :data="data"
        :tab-is-fixed="theme.tabIsFixed"
        :class="_.category"
        :style="{
          '--fixed-tab-themecolor': theme.fixedTabThemeColor,
          '--checked-fixed-tabcolor': theme.checkedFixedTabColor,
          '--unchecked-fixed-tabcolor': theme.unCheckedFixedTabColor,
        }"
      >
        <template #default="{ item, isActive }">
          <div
            v-track="{
              name: '活动瀑布流-分类栏',
              id: `${componentId}-category`,
              content: item.title,
            }"
            :class="[
              'item',
              _.item,
              isActive && _.active,
              isActive && 'active',
            ]"
          >
            {{ item.title }}
          </div>
        </template>
      </DmbcBaseTabs>
      <dmbc-base-waterfall
        ref="waterfall"
        no-complete-tips
        :tab-is-fixed="theme.tabIsFixed"
        :load="handleDataLoad"
      >
        <template #default="{ data }">
          <div
            v-if="theme.showRecommendStyle === true"
            v-track="{
              name: '活动瀑布流-商品-推荐',
              id: `${componentId}-goods-recommend`,
              resource: data[0],
            }"
            :class="_.special"
            @click="$dmbcResourceClick(data[0])"
          >
            <img :src="data[0].icon" :class="_.cover" />
            <div :class="_.content">
              <div :class="_.name">{{ data[0].title }}</div>
              <div v-if="data[0].tags.length" :class="_.tags">
                <div v-for="tag in data[0].tags" :key="tag" :class="_.tag">
                  {{ tag }}
                </div>
              </div>
              <div :class="_.grow"></div>
              <div :class="_.extra">
                <div :class="_.price">
                  <template v-if="+data[0].discountAmt">
                    <div :class="_.current">
                      <span>￥</span>{{ data[0].discountAmt
                      }}<i v-if="data[0].resType === '03'">起</i>
                    </div>
                    <div
                      v-if="
                        +data[0].amt && +data[0].amt !== +data[0].discountAmt
                      "
                      :class="_.cost"
                    >
                      ￥{{ data[0].amt }}
                    </div>
                  </template>
                </div>
                <div :class="_.button">立即购买</div>
              </div>
            </div>
          </div>
          <dmbc-base-masonry
            v-if="data.length > (theme.showRecommendStyle === true ? 1 : 0)"
            :col-count="2"
            :gap="7"
            :class="_.list"
          >
            <dmbc-base-resource
              v-for="(item, index) in data.slice(
                theme.showRecommendStyle === true ? 1 : 0,
              )"
              :key="item.id"
              :track="{
                name: '活动瀑布流-商品',
                id: `DianJiZiDingYiYeZiYuan`,
                resource: item,
                index: index,
                extra: getTrackExtra(item, index),
              }"
              :item="item"
              :cover-frame="theme.borderPic"
              :show-tags="theme.showLabel === true"
            />
          </dmbc-base-masonry>
        </template>
      </dmbc-base-waterfall>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    data: () => ({
      categoryIndex: 0,
    }),

    watch: {
      categoryIndex() {
        this.$refs.waterfall.reload()
      },
    },

    methods: {
      handleDataLoad({ pageNumber }) {
        return this.$dmbcApi.getComponentData({
          id: this.componentId,
          innerId: this.data[this.categoryIndex].id,
          pageIndex: pageNumber,
          pageSize: 10,
          useCdn: this.pageTheme.cdn,
        })
      },
    },
  })
</script>

<style lang="scss" module="_">
  .waterfall {
    font-size: 0;

    .bd {
      padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
        var(--padding-left);

      .category {
        --gap: 10px;
        --height: 32px;

        .item {
          padding: 5px 12px;
          background: var(--category-bgcolor);
          border-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          color: var(--category-color);
          line-height: 20px;

          &.active {
            background: var(--category-bgcolor-active);
            color: var(--category-color-active);
          }
        }
      }

      .special {
        margin-top: 12px;
        background: #ffffff;
        border-radius: 8px;
        padding: 12px;
        display: flex;
        align-items: stretch;

        .cover {
          flex-shrink: 0;
          width: 96px;
          height: 96px;
          object-fit: cover;
          border-radius: 6px;
        }

        .content {
          flex-grow: 1;
          margin-left: 12px;
          display: flex;
          flex-direction: column;

          .name {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            line-height: 20px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .tags {
            display: flex;
            flex-wrap: wrap;

            .tag {
              margin-top: 8px;
              margin-right: 8px;
              height: 23px;
              line-height: 23px;
              background: #fff4e6;
              border-radius: 4px;
              padding: 0 6px;
              font-size: 12px;
              color: #ff960a;
            }
          }

          .grow {
            flex-grow: 1;
          }

          .extra {
            margin-top: 4px;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;

            .price {
              display: flex;
              align-items: baseline;

              .current {
                font-size: 18px;
                font-weight: bold;
                color: #ff3b30;
                line-height: 25px;

                span {
                  font-size: 12px;
                  font-weight: normal;
                  color: #ff3b30;
                  line-height: 17px;
                }

                i {
                  font-style: normal;
                  margin-left: 2px;
                  font-size: 12px;
                  font-weight: normal;
                  color: #b4b4b4;
                  line-height: 17px;
                }
              }

              .cost {
                margin-left: 2px;
                font-size: 12px;
                color: #bebebe;
                line-height: 12px;
                text-decoration: line-through;
              }
            }

            .button {
              width: 88px;
              height: 32px;
              background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
              border-radius: 17px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 13px;
              font-weight: bold;
              color: #ffffff;
            }
          }
        }
      }

      .list {
        padding-top: 12px;
      }
    }
  }
</style>
